import {interfaceAnnotationRepository} from "../../../infrastructure/repository/impl/annotation_repository";
import {Annotation} from "../../entities/entities";

interface AnnotationUseCase {
  listAnnotations(videoID: number): Promise<Array<Annotation>>;
  saveAnnotation(annotation: Annotation): Promise<Annotation>;
  editAnnotation(annotation: Annotation): Promise<void>;
  deleteAnnotation(annotation: Annotation): Promise<void>;
}

class _AnnotationUseCase implements AnnotationUseCase {
  async listAnnotations(videoID: number): Promise<Array<Annotation>> {
    return interfaceAnnotationRepository.listAnnotations(videoID);
  }

  async saveAnnotation(annotation: Annotation): Promise<Annotation> {
    return interfaceAnnotationRepository.saveAnnotation(annotation);
  }

  async editAnnotation(annotation: Annotation): Promise<void> {
    return interfaceAnnotationRepository.editAnnotation(annotation);
  }

  async deleteAnnotation(annotation: Annotation): Promise<void> {
    return interfaceAnnotationRepository.deleteAnnotation(annotation);
  }
}

export const interfaceAnnotationUseCase: _AnnotationUseCase = new _AnnotationUseCase();
